import CookieManagerService from '../../../cookie-manager/service';

const analyticsCookiesConsent = function() {
  const service = new CookieManagerService();
  return service.analyticsCookiesEnabled();
};

export class GoogleAnalytics {
  constructor() {
    this.googleAnalytics = window.ga4;
    this.dataLayer = (window.dataLayer || [])[0] || {};
  }

  transactionId() {
    return window.App?.order?.order_id;
  }

  orderValue() {
    return Number(this.stripCurrencySymbol(this.dataLayer.cart_value));
  }

  currency() {
    return this.dataLayer.currency;
  }

  sendEvent(eventName, parameters) {
    this.analyticsEnabled() &&
      this.googleAnalytics('event', eventName, parameters);
  }

  stripCurrencySymbol(value = '') {
    const currency = window.currency?.symbol || '';

    return value.replace(currency, '');
  }

  analyticsEnabled() {
    return (
      typeof this.googleAnalytics !== 'undefined' && analyticsCookiesConsent()
    );
  }

  dataLayerEnabled() {
    return !!Object.keys(this.dataLayer).length;
  }
}
